type PushedRouterHrefListener = (href: string) => void;

const pushedRouterHrefListeners = new Set<PushedRouterHrefListener>();

/**
 * Subscribe to hrefs `pushWithExistingQuery` is about to write. Shallow Next navigations do not
 * reliably emit `routeChangeComplete` with that href, so listeners apply it in the same tick.
 */
export const subscribePushedRouterHref = (listener: PushedRouterHrefListener) => {
  pushedRouterHrefListeners.add(listener);

  return () => {
    pushedRouterHrefListeners.delete(listener);
  };
};

export const emitPushedRouterHref = (href: string) => {
  pushedRouterHrefListeners.forEach((listener) => {
    listener(href);
  });
};
